import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { RetroMarquee } from "./Marquee";
import { RulesDialog } from "./RulesDialog";
import { MuteToggle } from "./MuteToggle";
import { startMenuMusic, stopMenuMusic, playClick } from "../lib/sound";

export const StartScreen = ({ onStart }) => {
  const [team1, setTeam1] = useState("");
  const [team2, setTeam2] = useState("");
  const startedRef = useRef(false);

  // Start menu music on first user interaction (browser autoplay policy)
  useEffect(() => {
    const handler = () => {
      if (startedRef.current) return;
      startedRef.current = true;
      startMenuMusic();
      window.removeEventListener("pointerdown", handler);
      window.removeEventListener("keydown", handler);
    };
    window.addEventListener("pointerdown", handler);
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("pointerdown", handler);
      window.removeEventListener("keydown", handler);
      stopMenuMusic();
    };
  }, []);

  const submit = (e) => {
    e.preventDefault();
    playClick();
    stopMenuMusic();
    const t1 = team1.trim() || "Team Pink";
    const t2 = team2.trim() || "Team Blue";
    onStart({ team1: t1, team2: t2 });
  };

  return (
    <div className="min-h-screen bg-halftone flex flex-col" data-testid="start-screen">
      <RetroMarquee />

      {/* Floating mute toggle */}
      <div className="fixed top-16 right-4 z-50">
        <MuteToggle />
      </div>

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-3xl">
          <motion.div
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 90, damping: 14 }}
            className="text-center mb-12"
          >
            <div className="inline-block bg-[#FFD700] border-4 border-[#111111] shadow-brutal-md px-4 py-1 mb-4 -rotate-2">
              <span className="font-mono-debate font-bold uppercase tracking-[0.25em] text-sm">
                A Party Card Game
              </span>
            </div>
            <h1
              className="font-anton uppercase text-7xl md:text-9xl leading-[0.9] text-[#111111]"
              data-testid="game-title"
            >
              MASTER
              <br />
              <span className="text-[#FF2A54] inline-block -rotate-1">
                DEBATERS
              </span>
            </h1>
            <p className="font-outfit font-bold text-xl md:text-2xl mt-6 max-w-xl mx-auto">
              Two teams. Each player gets a secret card — a celebrity, a funny phrase, or a weird thing — plus a side (For or Against). Tap to reveal yours, hide it from your opponent, then debate your way to <span className="bg-[#FFD700] px-2">10 points</span>.
            </p>
          </motion.div>

          <motion.form
            onSubmit={submit}
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 80 }}
            className="bg-white border-4 border-[#111111] shadow-brutal-lg p-6 md:p-10"
          >
            <div className="mb-6">
              <label
                htmlFor="team1"
                className="font-mono-debate font-bold uppercase tracking-[0.2em] text-sm block mb-2"
              >
                Team 1 Name
              </label>
              <input
                id="team1"
                data-testid="team1-name-input"
                value={team1}
                onChange={(e) => setTeam1(e.target.value)}
                maxLength={20}
                placeholder="The Hot Takes"
                className="font-outfit font-bold text-2xl w-full p-4 bg-[#FFF4E0] border-4 border-[#111111] shadow-brutal-sm focus:outline-none focus:translate-x-[2px] focus:translate-y-[2px] focus:shadow-none transition-all"
              />
            </div>

            <div className="mb-8">
              <label
                htmlFor="team2"
                className="font-mono-debate font-bold uppercase tracking-[0.2em] text-sm block mb-2"
              >
                Team 2 Name
              </label>
              <input
                id="team2"
                data-testid="team2-name-input"
                value={team2}
                onChange={(e) => setTeam2(e.target.value)}
                maxLength={20}
                placeholder="The Loud Crowd"
                className="font-outfit font-bold text-2xl w-full p-4 bg-[#FFF4E0] border-4 border-[#111111] shadow-brutal-sm focus:outline-none focus:translate-x-[2px] focus:translate-y-[2px] focus:shadow-none transition-all"
              />
            </div>

            <div className="mb-6">
            </div>

            <button
              type="submit"
              data-testid="start-game-btn"
              className="btn-brutal-press w-full bg-[#FF2A54] text-white border-4 border-[#111111] shadow-brutal-md font-anton uppercase text-4xl md:text-5xl py-6"
            >
              Start The Madness
            </button>

            <p className="font-mono-debate text-xs uppercase tracking-widest text-center mt-4 text-[#111111]/60">
              Pass-and-play • First team to 10 wins
            </p>

            <div className="mt-4 flex justify-center">
              <RulesDialog />
            </div>
          </motion.form>
        </div>
      </div>
    </div>
  );
};
